import { render, staticRenderFns } from "./pageHeaderContent.vue?vue&type=template&id=92cffbf4&scoped=true&"
import script from "./pageHeaderContent.vue?vue&type=script&lang=js&"
export * from "./pageHeaderContent.vue?vue&type=script&lang=js&"
import style0 from "./pageHeaderContent.vue?vue&type=style&index=0&id=92cffbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cffbf4",
  null
  
)

export default component.exports